<template>
  <div class="about">
    <Header 
      title="Servidores Forfun" 
      subtitle="Deathmatch pra aquecer sua mira :)"
    ></Header>
    <div class="container">

      <div class="server-list">
        <a :href="`steam://connect/${server.server_ip}`" :class="`gs-widget ${server.map_name}`" v-for="server in servers" :key="server.id">
          <p class="hostname">{{server.server_name}}</p>
          <p class="map"><span class="icon is-small"><i class="fa fa-bullseye"></i></span> {{server.map_name}}</p>
          <p class="players"><span class="icon is-small"><i class="fa fa-users"></i></span> {{server.number_of_players}}/{{server.max_players}}</p>
        </a>

      </div>

    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'ForfunServerList',
  metaInfo: {
    title: 'Servidores Forfun'
  },
  data () {
    return {
      servers: null
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('pug_servers.json')
        .then(response => (this.servers = response.data))
      
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
.server-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  .gs-widget {
    width: 49%;
  }
}

.gs-widget {
  display: block;
  background: #333333;
  padding: 20px 20px;
  color: rgba(255, 255, 255, .5);
  filter: contrast(130%);
  transition: all .1s;
  &:hover {
    filter: contrast(160%);
    text-decoration: none;
  }

  span.icon {
    font-size: 13px;
  }

  &:not(:last-child) {
    margin-bottom: 6px;
  }

  p {
    margin: 0 !important;
    padding: 0 !important;
    &.hostname {
      font-weight: bold;
    }
    &.map {}
    &.players {
      font-weight: bold;
      color: white;
    }
  }
}
</style>
